import { BadgeConfig } from "./clubBadges";
import { getFlagUrl } from "./nationalityFlags";

/**
 * Returns a BadgeConfig that renders the country's actual flag clipped to the
 * shield shape. Falls back to a neutral grey badge for unknown nationalities.
 */
export function getNationalityBadge(nationality: string | null | undefined): BadgeConfig {
  if (!nationality) return defaultNationalityBadge;

  const flagUrl = getFlagUrl(nationality);
  if (flagUrl) {
    return {
      // Colour fields are required by BadgeConfig but unused when flagUrl is set
      primary: "#888888",
      secondary: "#CCCCCC",
      pattern: "solid",
      flagUrl,
    };
  }

  return defaultNationalityBadge;
}

const defaultNationalityBadge: BadgeConfig = {
  primary: "#888888",
  secondary: "#CCCCCC",
  pattern: "solid",
};
